import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import LinkScriptPartnerships from '../link-script/partnerships/link-script-partnerships'
import PartnershipDetail from '../link-script/partnerships/partnership-detail'
import PartnershipPrint from '../link-script/partnerships/partnership-print'

export default function PartnershipsPage() {
  const location = useLocation()
  if (/^\/partnerships\/[^/]+\/print$/.test(location.pathname)) return <PartnershipPrint />
  const detailMatch = location.pathname.match(/^\/partnerships\/([^/]+)$/)
  if (detailMatch) return <Navigate to={`/partnerships/${detailMatch[1]}/overview${location.search}`} replace />
  if (/^\/partnerships\/[^/]+\/(overview|conversions|settings)$/.test(location.pathname)) return <PartnershipDetail />
  return <LinkScriptPartnerships />
}
